module.exports = __webpack_public_path__ + "static/media/animate.6320efd3.svg";